module.exports = __webpack_public_path__ + "img/unknown_file.c6ac17b5.png";